<template>
    <!-- 选择对应的商户 -->
    <vuestic-modal :show.sync="multipleMerchant"
                  ref="multipleMerchant"
                  :okText="'modal.confirm2' | translate"
                  style="height: 100%;width:60vw;"
                  :okClass="'btn btn-primary btn-micro'"
                  :cancelClass="'btn btn-secondary btn-micro'"
                  :cancelText="'modal.cancel2' | translate"
                  alignModal="change-password-show"
                  :force="true">
      <div slot="title">Please select an account</div>
      <div class="multiple-merchant">
        <div class="select-merchant">
          <div
            v-for="option in merchantOptions"
            :key="option.value"
            :class="[
              'radio-title',
              {
                'selected': selectedMerchant === option.value,
                'disabled': option.disabled
              }
            ]"
            @click="selectOption(option)"
          >
            <div class="title-content">
              <!-- 图标指示器 -->
              <div class="check-icon">
                <svg v-show="selectedMerchant === option.value" width="24" height="24" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              </div>
              <!-- 内容插槽 -->
              <div class="title-header">
                <h3 class="title">{{ option.label }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vuestic-modal>
</template>

<script>
import { request } from '@/utils/utils.js'
import store from "@/store/index";

export default {
  data() {
    return {
      multipleMerchant: true,
      merchantOptions: [],
      selectedMerchant: null
    }
  },
  watch: {
    $route (route) {
      let isEasyPassword = localStorage.getItem('isEasyPassword');
      if (eval(isEasyPassword)) {
        // 优先处理密码问题
        return
      }
      const userDataObject = this.getUserData()
      let { merchants, merchantNoSelected } = userDataObject
      if (merchants && merchants.length === 0) {
        // 没有merchants不弹出
        return
      }
      if (merchants && !merchantNoSelected) {
        this.merchantOptions = []
        for (const [key, value] of Object.entries(merchants)) {
          this.merchantOptions.push({ label: `${value}@${key}`, value: key })
        }
        this.selectedMerchant = this.merchantOptions[0].value
        this.init()
        this.isShowMask = true
        this.$refs.multipleMerchant.open()
      }
    }
  },
  methods: {
    getUserData() {
      let userData = {}
      try {
        userData = JSON.parse(localStorage.getItem('userData') || '{}');
      } catch (error) {}
      return userData
    },
    init() {
      const that = this
      that.$refs.multipleMerchant.ok = () => {
        const userDataObject = that.getUserData()
        userDataObject.merchantNoSelected = that.selectedMerchant
        localStorage.setItem("userData", JSON.stringify(userDataObject));
        const merchants = userDataObject.merchants
        localStorage.setItem("merchantNo", that.selectedMerchant);
        localStorage.setItem("merchantName", merchants[that.selectedMerchant]);
        store.dispatch('datasource/SetMerchantNo', that.selectedMerchant)
        that.$refs.multipleMerchant.close()
      }
      that.$refs.multipleMerchant.cancel = () => {
        that.logout()
      }
    },
    selectOption(option) {
      if (!option.disabled) {
        this.selectedMerchant = option.value
      }
    },
    logout () {
      let token = localStorage.getItem('Authorization')
      request({
        method: 'delete',
        url: 'api/dashboard/logout?access_token=' + token,
      }).then(res => {
        localStorage.clear();
        location.href = "/auth/login";
      })
    }
  }
}
</script>

<style lang="scss">
.multiple-merchant {
  height: 180px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
    height: 12px; /* 高度 */
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background: $VUE_APP_COLOR4;
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
  .select-merchant {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.2rem;
    padding: 1rem 0 2rem;
  }

  .radio-title {
    position: relative;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    background: white;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .radio-title:hover:not(.selected):not(.disabled) {
    border-color: $action-color; // #90caf9;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(144, 202, 249, 0.2);
  }

  .radio-title.selected {
    border-color: $vue-green;
    /* background: linear-gradient(135deg, #f8fdff 0%, #e3f2fd 100%); */
    animation: title-pulse 1.5s ease-in-out infinite alternate;
  }

  @keyframes title-pulse {
    0% { box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.1); }
    100% { box-shadow: 0 0 0 8px rgba(33, 150, 243, 0); }
  }

  .title-content {
    padding: 1rem;
    position: relative;
  }

  .check-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    color: $vue-green;
    transform: scale(0.9);
    transition: transform 0.2s ease;
  }

  .selected .check-icon {
    transform: scale(1);
  }

  .title-header {
    margin-right: 32px;
  }

  .title {
    font-size: 0.9rem;
    color: #757575;
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 600;
    line-height: 1.4;
  }

  .selected .title {
    font-size: 0.9rem;
    color: #212121;
    word-wrap: break-word;
  }

  .radio-title.disabled {
    opacity: 0.6;
    filter: grayscale(0.8);
    cursor: not-allowed;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .select-merchant {
      grid-template-columns: 1fr;
    }

    .radio-title {
      margin: 0 8px;
    }
  }
}
</style>
